'use client';

export { default } from './Fade';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/Fade/index.js
// module id = 327
// module chunks = 25